import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';

import DaleIcon from '../../../images/icons/dale.png';
import PortalIcon from '../../../images/icons/portal.png';

const NotificationItem = ({ notification, handleNotificationClick, handleNotificationCollapse }) => {
	const { 
		id,
		title,
		notice,
		viewed,
		type,
		collapsed,
	} = notification;
	const classes = cs('notifications__item', { 'notifications__item--new': !viewed }, { 'notifications__item--collapse': collapsed });
	const icon = type === 'portal' ? PortalIcon : DaleIcon;
	const materialIcon = collapsed ? "expand_more_icon" : "expand_less_icon";
	
	return (
		<li className={classes}>
			<div className="notification card--shadow">
				<div className="notification__icon"><img src={icon} alt="" /></div>
				<div className="notification__content">
					<h2 className="notification__title" 
					    onClick={() => handleNotificationClick(title)}
					    dangerouslySetInnerHTML={{__html: title}} />
					<div dangerouslySetInnerHTML={{__html: notice}} />
				</div>
				<div className="notification__material-icon" onClick={() => handleNotificationCollapse(id)}>
					<span className="material-icons">{materialIcon}</span>
				</div>
			</div>
		</li>
	);
};

NotificationItem.propTypes = {
	notification: PropTypes.shape({
		id: PropTypes.number.isRequired,
		title: PropTypes.string.isRequired,
		notice: PropTypes.string.isRequired,
		viewed: PropTypes.bool.isRequired,
		collapsed: PropTypes.bool.isRequired,
	}).isRequired,
	handleNotificationClick: PropTypes.func.isRequired,
	handleNotificationCollapse: PropTypes.func.isRequired,
}

export default NotificationItem;


// WEBPACK FOOTER //
// ./src/components/routes/Notifications/NotificationItem.js